export const articles = [
  {
    id: "a01",
    title: "2026 华语乐坛年度巡演大盘点：从体育馆到音乐节的迁徙",
    summary:
      "当大型体育馆演唱会一票难求，越来越多的音乐人把重心转向户外音乐节。我们盘点了今年最值得关注的十场巡演，以及它们背后的行业逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=Wide%20outdoor%20music%20festival%20crowd%20at%20golden%20hour%20with%20warm%20orange%20stage%20light%20and%20haze%2C%20stylized%20editorial%20photography%2C%20grainy%20texture%2C%20deep%20charcoal%20shadows%2C%20cinematic%20contrast&width=1200&height=800&seq=lulu-art-01&orientation=landscape",
    category: "music",
    tags: ["巡演", "音乐节", "行业观察"],
    author: "陈牧野",
    date: "2026-10-12",
    views: 48210,
    readTime: 8,
    featured: true,
    hot: true,
  },
  {
    id: "a02",
    title: "暑期档复盘：类型片突围背后的叙事进化",
    summary:
      "票房结构正在被重塑。悬疑、科幻与现实主义题材各自找到了更精准的观众，我们复盘了这个暑期档最值得研究的五个案例。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinema%20screening%20room%20with%20warm%20projector%20beam%20cutting%20through%20dark%20air%2C%20editorial%20poster%20art%2C%20deep%20charcoal%20and%20amber%20glow%2C%20grainy%20texture%2C%20cinematic%20contrast&width=1200&height=800&seq=lulu-art-02&orientation=landscape",
    category: "film",
    tags: ["暑期档", "类型片", "票房"],
    author: "林岸",
    date: "2026-10-11",
    views: 39640,
    readTime: 9,
    featured: false,
    hot: true,
  },
  {
    id: "a03",
    title: "2026 秋冬秀场趋势：廓形、材质与「低调奢华」的回归",
    summary:
      "夸张装饰让位于剪裁本身。本季四大时装周传递出一个明确信号：安静的质感正在取代喧哗的Logo。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20fashion%20runway%20with%20abstract%20oversized%20coat%20silhouette%20in%20soft%20beige%2C%20editorial%20poster%20art%2C%20warm%20neutral%20palette%20with%20burnt%20orange%20accent%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-03&orientation=landscape",
    category: "fashion",
    tags: ["时装周", "趋势", "设计"],
    author: "苏晚",
    date: "2026-10-10",
    views: 28870,
    readTime: 7,
    featured: true,
    hot: true,
  },
  {
    id: "a04",
    title: "街头文化进行时：从滑板场到美术馆的三十年",
    summary:
      "曾被视作「不登大雅之堂」的街头表达，如今成为美术馆的常客。我们梳理了这段被主流逐渐收编，又不断自我更新的历史。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20urban%20concrete%20skate%20park%20with%20abstract%20graffiti%20shapes%20and%20long%20shadows%2C%20editorial%20poster%20art%2C%20grey%20concrete%20with%20orange%20and%20blue%20accents%2C%20grainy%20texture&width=1200&height=800&seq=lulu-art-04&orientation=landscape",
    category: "trend",
    tags: ["街头文化", "亚文化", "城市"],
    author: "何野",
    date: "2026-10-09",
    views: 31250,
    readTime: 10,
    featured: false,
    hot: true,
  },
  {
    id: "a05",
    title: "新生代独立乐队崛起：卧室制作人如何改写流行版图",
    summary:
      "一台笔记本、一支麦克风，就能完成一张专辑。独立音乐的生产方式正在被彻底重构，并把新的声音推上主流舞台。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20bedroom%20home%20studio%20with%20laptop%20keyboard%20and%20warm%20lamp%20light%2C%20editorial%20poster%20art%2C%20warm%20amber%20and%20deep%20charcoal%20palette%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-05&orientation=landscape",
    category: "music",
    tags: ["独立音乐", "制作", "新人"],
    author: "陈牧野",
    date: "2026-10-08",
    views: 21430,
    readTime: 6,
    featured: false,
    hot: false,
  },
  {
    id: "a06",
    title: "华语悬疑剧的黄金时代：从社会派推理到心理惊悚",
    summary:
      "当类型剧开始认真处理现实议题，悬疑就不再只是解谜游戏。我们聊了聊这几年最好看的几部作品到底好在哪。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20noir%20city%20street%20at%20night%20with%20neon%20reflections%20and%20fog%2C%20editorial%20poster%20art%2C%20deep%20blue%20and%20amber%20accents%20on%20charcoal%2C%20grainy%20texture%2C%20cinematic%20contrast&width=1200&height=800&seq=lulu-art-06&orientation=landscape",
    category: "film",
    tags: ["悬疑", "剧集", "评论"],
    author: "林岸",
    date: "2026-10-07",
    views: 26980,
    readTime: 8,
    featured: false,
    hot: false,
  },
  {
    id: "a07",
    title: "可持续时尚不是口号：从面料创新到二手交易生态",
    summary:
      "当「环保」成为营销关键词，真正改变行业的却是实验室里的面料与二手平台上的流通。这是一份务实的观察。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20textile%20swatches%20in%20natural%20tones%20arranged%20in%20a%20grid%20with%20soft%20light%2C%20editorial%20poster%20art%2C%20beige%20sage%20and%20terracotta%20palette%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-07&orientation=landscape",
    category: "fashion",
    tags: ["可持续", "环保", "消费"],
    author: "苏晚",
    date: "2026-10-06",
    views: 15320,
    readTime: 7,
    featured: false,
    hot: false,
  },
  {
    id: "a08",
    title: "Y2K 再定义：复古潮如何被 Z 世代重新编码",
    summary:
      "千禧年审美被反复翻拍，但这一次的 Y2K 不是怀旧，而是新的身份表达。我们拆解了它流行的三个底层原因。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20retro%20Y2K%20aesthetic%20still%20life%20with%20chrome%20shapes%20and%20plastic%20gloss%2C%20editorial%20poster%20art%2C%20warm%20orange%20and%20silver%20accents%20on%20cream%2C%20grainy%20texture%2C%20playful%20composition&width=1200&height=800&seq=lulu-art-08&orientation=landscape",
    category: "trend",
    tags: ["Y2K", "复古", "Z世代"],
    author: "何野",
    date: "2026-10-05",
    views: 33120,
    readTime: 6,
    featured: false,
    hot: true,
  },
  {
    id: "a09",
    title: "黑胶复兴进行时：年轻人为什么重新爱上实体唱片",
    summary:
      "在流媒体无限供给的时代，黑胶反而卖得越来越好。我们去了几家独立唱片店，想搞清楚这种「低效」为何迷人。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20vinyl%20records%20stacked%20on%20a%20wooden%20shelf%20with%20warm%20lamp%20glow%2C%20editorial%20poster%20art%2C%20warm%20amber%20and%20deep%20brown%20palette%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-09&orientation=landscape",
    category: "music",
    tags: ["黑胶", "实体唱片", "生活方式"],
    author: "陈牧野",
    date: "2026-10-04",
    views: 18760,
    readTime: 6,
    featured: false,
    hot: false,
  },
  {
    id: "a10",
    title: "纪录片正在变年轻：短剧集与竖屏叙事的实验",
    summary:
      "长纪录片之外，一批更轻、更快、更贴近手机观看习惯的作品正在出现。它们改变了什么，又放弃了什么？",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20smartphone%20tripod%20filming%20a%20documentary%20scene%20in%20warm%20daylight%2C%20editorial%20poster%20art%2C%20warm%20neutral%20palette%20with%20orange%20accent%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-10&orientation=landscape",
    category: "film",
    tags: ["纪录片", "竖屏", "内容形态"],
    author: "林岸",
    date: "2026-10-03",
    views: 12240,
    readTime: 7,
    featured: false,
    hot: false,
  },
  {
    id: "a11",
    title: "配饰即态度：小包、金属链条与结构化鞋履的崛起",
    summary:
      "当服装趋于克制，配饰成了表达重心的出口。本季最值得入手的几类单品，以及它们该怎么搭。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20still%20life%20of%20a%20structured%20mini%20bag%20with%20metal%20chain%20on%20a%20stone%20surface%2C%20editorial%20poster%20art%2C%20cream%20and%20burnt%20orange%20palette%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-11&orientation=landscape",
    category: "fashion",
    tags: ["配饰", "造型", "单品"],
    author: "苏晚",
    date: "2026-10-02",
    views: 16980,
    readTime: 5,
    featured: false,
    hot: false,
  },
  {
    id: "a12",
    title: "城市漫游 Citywalk：年轻人的新社交货币",
    summary:
      "不打卡景点、不赶行程，只是沿着街道慢慢走。Citywalk 为什么能成为这一代人的共同语言？",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20empty%20city%20street%20with%20old%20buildings%20and%20warm%20afternoon%20light%2C%20editorial%20poster%20art%2C%20warm%20terracotta%20and%20cream%20palette%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=800&seq=lulu-art-12&orientation=landscape",
    category: "trend",
    tags: ["Citywalk", "城市", "生活"],
    author: "何野",
    date: "2026-10-01",
    views: 24310,
    readTime: 6,
    featured: false,
    hot: false,
  },
  {
    id: "a13",
    title: "旋律之外：影视原声带如何成为流行金曲制造机",
    summary:
      "一首歌因为一部剧被听见，也因为剧情被记住。OST 正在成为歌手出圈最有效的通道之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20orchestra%20pit%20with%20sheet%20music%20and%20warm%20bokeh%20lights%2C%20editorial%20poster%20art%2C%20warm%20amber%20and%20deep%20charcoal%20palette%2C%20grainy%20texture%2C%20cinematic%20contrast&width=1200&height=800&seq=lulu-art-13&orientation=landscape",
    category: "music",
    tags: ["OST", "影视音乐", "单曲"],
    author: "陈牧野",
    date: "2026-09-29",
    views: 14200,
    readTime: 6,
    featured: false,
    hot: false,
  },
  {
    id: "a14",
    title: "国际影展巡礼：亚洲导演在红毯之外的表达",
    summary:
      "入围与获奖之外，影展真正的意义在于让不同语境的作品被看见。我们记录了今年几部值得关注的亚洲新片。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20film%20festival%20red%20carpet%20with%20abstract%20spotlights%20and%20bokeh%2C%20editorial%20poster%20art%2C%20deep%20red%20and%20amber%20palette%20on%20charcoal%2C%20grainy%20texture%2C%20cinematic%20contrast&width=1200&height=800&seq=lulu-art-14&orientation=landscape",
    category: "film",
    tags: ["影展", "亚洲电影", "新片"],
    author: "林岸",
    date: "2026-09-27",
    views: 11890,
    readTime: 8,
    featured: false,
    hot: false,
  },
];